export default function Overview() {
  const points = [
    {
      icon: "ri-user-heart-line",
      title: "一条主线",
      text: "整起事件围绕核心当事人之间的直接交集展开，绝大多数连线都由这条主线向外辐射。",
    },
    {
      icon: "ri-group-line",
      title: "两层关联",
      text: "第一层是经纪、公关等近身机构，第二层是媒体、品牌与资本，越往外层信息越间接。",
    },
    {
      icon: "ri-shuffle-line",
      title: "多次转向",
      text: "随着不同阶段发声对象切换，讨论焦点不断转移，催生出多种彼此参照的叙事版本。",
    },
  ];

  return (
    <section id="overview" className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid gap-8 lg:grid-cols-5 lg:gap-12">
        <div className="lg:col-span-2">
          <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-[#b4372a]">
            <span className="h-px w-6 bg-[#b4372a]"></span>事件一览
          </p>
          <h2 className="mt-3 font-serif-sc text-3xl font-black leading-snug text-[#2a2320] md:text-4xl">
            它不止是一场热议，更是一张正在成型的<b className="text-[#b4372a]">关系网络</b>
          </h2>
          <p className="mt-4 leading-relaxed text-[#5a5049]">
            吃瓜门之所以难懂，在于信息碎片化地分散在多个发言对象手里，而他们彼此之间的真实距离，
            往往被转发与评论掩盖。把人物、机构与群体按关系类型连线后，整件事的骨架便清晰起来：
            谁处于核心，谁是枢纽，谁只是被卷入的外围。
          </p>
          <a
            href="#graph"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap text-[#b4372a] transition hover:text-[#98301f]"
          >
            进入可交互图谱 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="grid gap-4 lg:col-span-3 sm:grid-cols-3">
          {points.map((p) => (
            <article
              key={p.title}
              className="rounded-lg border border-[#eadccb] bg-white p-5 transition hover:border-[#d9a06b]"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-[#f7e4d6] text-[#b4372a]">
                <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-serif-sc text-lg font-bold text-[#2a2320]">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#7a6f66]">{p.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}